// Overrides for active legacy UI keys found missing or still inherited from English.
export default {
  "zh-CN": {
    "Hi": "你好",
    "common": {
      "confirmClearCache": "您确定要清除缓存吗？",
      "confirmDeleteHistory": "您确定要删除此历史记录项目吗？",
      "contactAdvisor": "请联系您的顾问",
      "deleteFailed": "删除失败",
      "deleteSuccess": "删除成功",
      "imageTooLarge": "图片太大",
      "loadFailed": "加载失败",
      "networkError": "网络错误，请重试",
      "noMore": "没有更多数据",
      "refreshSuccess": "刷新成功",
      "uploadFailed": "上传失败",
      "uploading": "正在上传..."
    },
    "login": {
      "loginFailed": "登录失败，请重试"
    }
  },
  "vi": {
    "Hi": "Xin chào",
    "common": {
      "confirmClearCache": "Bạn có chắc chắn muốn xóa bộ nhớ cache không?",
      "confirmDeleteHistory": "Bạn có chắc chắn muốn xóa mục lịch sử này không?",
      "contactAdvisor": "Vui lòng liên hệ với cố vấn của bạn",
      "deleteFailed": "Xóa không thành công",
      "deleteSuccess": "Đã xóa thành công",
      "imageTooLarge": "Hình ảnh quá lớn",
      "loadFailed": "Tải không thành công",
      "networkError": "Lỗi mạng. Vui lòng thử lại",
      "noMore": "Không còn dữ liệu",
      "refreshSuccess": "Đã làm mới thành công",
      "uploadFailed": "Tải lên không thành công",
      "uploading": "Đang tải lên..."
    },
    "login": {
      "loginFailed": "Đăng nhập không thành công. Vui lòng thử lại"
    },
    "moneylog": {
      "summary": "Tóm tắt"
    }
  },
  "hi": {
    "Hi": "नमस्ते",
    "choose": {
      "giftAmount": "गिफ़्ट की राशि",
      "giftBalance": "उपलब्ध बैलेंस",
      "giftConfirm": "गिफ़्ट कन्फ़र्म करें",
      "giftCustomPlaceholder": "कस्टम राशि डालें",
      "giftInsufficient": "अपर्याप्त बैलेंस",
      "giftInvalid": "कृपया कोई मान्य गिफ़्ट राशि डालें",
      "giftPoints": "पॉइंट",
      "giftSending": "भेजा जा रहा है...",
      "giftSuccess": "गिफ़्ट सफलतापूर्वक भेजा गया",
      "giftTitle": "गिफ़्ट भेजें"
    },
    "common": {
      "confirmClearCache": "क्या आप वाकई कैश साफ़ करना चाहते हैं?",
      "confirmDeleteHistory": "क्या आप वाकई इस इतिहास आइटम को हटाना चाहते हैं?",
      "contactAdvisor": "कृपया अपने सलाहकार से संपर्क करें",
      "deleteFailed": "मिटाया नहीं जा सका",
      "deleteSuccess": "सफलतापूर्वक हटाया गया",
      "imageTooLarge": "फ़ोटो बहुत बड़ी है",
      "loadFailed": "लोड नहीं हो सका",
      "networkError": "नेटवर्क में गड़बड़ी हुई। कृपया फिर से कोशिश करें",
      "noMore": "कोई और डेटा नहीं",
      "refreshSuccess": "सफलतापूर्वक रीफ़्रेश किया गया",
      "uploadFailed": "अपलोड नहीं हो सका",
      "uploading": "अपलोड हो रहा है..."
    },
    "login": {
      "loginFailed": "लॉग इन नहीं हो सका। कृपया फिर से कोशिश करें"
    },
    "moneylog": {
      "summary": "सारांश"
    }
  },
  "th": {
    "Hi": "สวัสดี",
    "choose": {
      "giftAmount": "ยอดของขวัญ",
      "giftBalance": "ยอดคงเหลือที่ใช้ได้",
      "giftConfirm": "ยืนยันของขวัญ",
      "giftCustomPlaceholder": "ระบุยอดที่กำหนดเอง",
      "giftInsufficient": "ยอดคงเหลือไม่เพียงพอ",
      "giftInvalid": "โปรดกรอกจำนวนของขวัญที่ถูกต้อง",
      "giftPoints": "คะแนน",
      "giftSending": "กำลังส่ง...",
      "giftSuccess": "ส่งของขวัญเรียบร้อยแล้ว",
      "giftTitle": "ส่งของขวัญ"
    },
    "common": {
      "confirmClearCache": "แน่ใจไหมว่าต้องการล้างแคช?",
      "confirmDeleteHistory": "คุณแน่ใจหรือไม่ว่าต้องการลบรายการประวัตินี้?",
      "contactAdvisor": "โปรดติดต่อที่ปรึกษาของคุณ",
      "deleteFailed": "การลบล้มเหลว",
      "deleteSuccess": "ลบเรียบร้อยแล้ว",
      "imageTooLarge": "ภาพมีขนาดใหญ่เกินไป",
      "loadFailed": "โหลดไม่สำเร็จ",
      "networkError": "เกิดข้อผิดพลาดของเครือข่ายโปรดลองอีกครั้ง",
      "noMore": "ไม่มีข้อมูลอีกต่อไป",
      "refreshSuccess": "รีเฟรชเรียบร้อยแล้ว",
      "uploadFailed": "อัพโหลดไม่สำเร็จ",
      "uploading": "กำลังอัปโหลด..."
    },
    "login": {
      "loginFailed": "การเข้าสู่ระบบล้มเหลวโปรดลองอีกครั้ง"
    },
    "moneylog": {
      "summary": "สรุป"
    }
  },
  "ru": {
    "Hi": "Здравствуйте,!",
    "choose": {
      "giftAmount": "Сумма подарка",
      "giftBalance": "Доступный баланс",
      "giftConfirm": "Подтвердить подарок",
      "giftCustomPlaceholder": "Введите пользовательскую сумму",
      "giftInsufficient": "Недостаточный баланс",
      "giftInvalid": "Введите действительную сумму подарка",
      "giftPoints": "Баллы",
      "giftSending": "Отправка...",
      "giftSuccess": "Подарок успешно отправлен",
      "giftTitle": "Отправить подарок"
    },
    "common": {
      "confirmClearCache": "Вы уверены, что хотите очистить кэш?",
      "confirmDeleteHistory": "Вы уверены, что хотите удалить этот элемент истории?",
      "contactAdvisor": "Обратитесь к своему консультанту",
      "deleteFailed": "Не удалось удалить",
      "deleteSuccess": "Успешно удалено",
      "imageTooLarge": "Изображение слишком большое",
      "loadFailed": "Не удалось загрузить",
      "networkError": "Ошибка сети. Повторите попытку",
      "noMore": "Нет больше данных",
      "refreshSuccess": "Обновлено успешно",
      "uploadFailed": "Не удалось загрузить",
      "uploading": "Загрузка..."
    },
    "login": {
      "loginFailed": "Не удалось войти в систему. Повторите попытку"
    },
    "moneylog": {
      "summary": "Раскрытие сущности"
    }
  },
  "ko": {
    "Hi": "안녕하세요",
    "choose": {
      "giftAmount": "선물 금액",
      "giftBalance": "사용 가능한 잔액",
      "giftConfirm": "선물 확인",
      "giftCustomPlaceholder": "맞춤 금액을 입력하세요",
      "giftInsufficient": "잔액 부족",
      "giftInvalid": "올바른 기프트 카드 금액을 입력하세요.",
      "giftPoints": "포인트",
      "giftSending": "전송 중...",
      "giftSuccess": "선물이 성공적으로 전송되었습니다",
      "giftTitle": "선물 보내기"
    },
    "common": {
      "confirmClearCache": "정말로 캐시를 지우시겠습니까?",
      "confirmDeleteHistory": "정말로 이 기록 항목을 삭제하시겠습니까?",
      "contactAdvisor": "상담사에게 문의하십시오",
      "deleteFailed": "삭제 실패",
      "deleteSuccess": "성공적으로 삭제되었습니다",
      "imageTooLarge": "이미지가 너무 큽니다",
      "loadFailed": "로딩 실패",
      "networkError": "네트워크 오류입니다. 다시 시도하십시오.",
      "noMore": "더 이상 데이터 없음",
      "refreshSuccess": "성공적으로 새로 고침됨",
      "uploadFailed": "업로드 실패",
      "uploading": "업로드 중..."
    },
    "login": {
      "loginFailed": "로그인에 실패했습니다. 다시 시도하세요."
    },
    "moneylog": {
      "summary": "요약"
    }
  },
  "jp": {
    "Hi": "こんにちは",
    "choose": {
      "giftAmount": "ギフトの金額",
      "giftBalance": "利用可能な残高",
      "giftConfirm": "ギフトを確定する",
      "giftCustomPlaceholder": "カスタム金額を入力してください",
      "giftInsufficient": "残高が不足しています",
      "giftInvalid": "有効なギフト金額を入力してください",
      "giftPoints": "ポイント",
      "giftSending": "送信しています...",
      "giftSuccess": "ギフトが正常に送信されました",
      "giftTitle": "ギフトを贈る"
    },
    "common": {
      "confirmClearCache": "キャッシュをクリアしてもよろしいですか？",
      "confirmDeleteHistory": "この履歴項目を削除してもよろしいですか？",
      "contactAdvisor": "アドバイザーにお問い合わせください",
      "deleteFailed": "削除に失敗しました",
      "deleteSuccess": "正常に削除されました",
      "imageTooLarge": "画像が大きすぎます",
      "loadFailed": "読み込みに失敗しました",
      "networkError": "ネットワークエラー。もう一度やり直してください",
      "noMore": "これ以上のデータはありません",
      "refreshSuccess": "正常に更新されました",
      "uploadFailed": "アップロードに失敗しました",
      "uploading": "アップロードしています..."
    },
    "login": {
      "loginFailed": "ログインに失敗しました。もう一度お試しください"
    },
    "moneylog": {
      "summary": "概要"
    }
  },
  "es": {
    "Hi": "Hola",
    "common": {
      "noMore": "No hay más datos",
      "addbank": "Añadir tarjeta de pago",
      "confirmClearCache": "¿Está seguro de que desea borrar la caché?",
      "confirmDeleteHistory": "¿Está seguro de que desea eliminar este elemento del historial?",
      "contactAdvisor": "Ponte en contacto con tu asesor",
      "deleteFailed": "Error al eliminar",
      "deleteSuccess": "Eliminado correctamente",
      "imageTooLarge": "La imagen es demasiado grande",
      "noallow": "¡La función está desactivada!",
      "pingluntitle": "Evaluaciones del gerente",
      "pldtitle": "Revisar detalles",
      "setbank": "Registrar cuenta de retiro",
      "uploadFailed": "Error al cargar",
      "uploading": "Subiendo..."
    },
    "login": {
      "loginFailed": "Error al iniciar sesión. Por favor, inténtelo de nuevo"
    },
    "moneylog": {
      "summary": "Resumen",
      "type2": "Bonificación",
      "type4": "Bonificación"
    },
    "accountOffline": "Cuenta sin conexión",
    "author": "Autor:",
    "bankCard": "Tarjeta bancaria",
    "choose": {
      "detail": "Detalles",
      "giftAmount": "Importe del regalo",
      "giftBalance": "Saldo disponible",
      "giftConfirm": "Confirmar regalo",
      "giftCustomPlaceholder": "Introduce un importe personalizado",
      "giftInsufficient": "Saldo insuficiente",
      "giftInvalid": "Introduce un importe de regalo válido",
      "giftPoints": "Puntos",
      "giftSending": "Enviando...",
      "giftSuccess": "Regalo enviado correctamente",
      "giftTitle": "Envía un regalo",
      "jianjie": "Perfil del gerente",
      "move": "Movilidad disponible",
      "videodetail": "Vídeo en directo"
    },
    "completeTaskForMore": "Completa las tareas para conseguir más entradas para el cine",
    "home": {
      "gaoji": "Premium"
    },
    "movieTicket": "Entrada de cine:",
    "myMovie": "Mi película",
    "orderContentLabel": "Contenido del pedido:",
    "personalReport": "Informe personal",
    "points": "Puntos",
    "possible": "Posible",
    "privacyPolicy": "Política de privacidad",
    "profitAmount": "Importe del beneficio",
    "profitFormula": "Fórmula de cálculo de beneficios: Importe ganador - Importe de la tarea",
    "quantity": "Cantidad:",
    "romanticDescription": "Nuestro servicio romántico protege la privacidad de los miembros al exigir la verificación del nombre real o la recomendación de los miembros verificados para registrarse.",
    "setname": {
      "notreset": "¡No repita los ajustes!",
      "plsentername": "¡Por favor, introduzca el nombre!",
      "tips": "Para la seguridad de su cuenta, el nombre real debe coincidir con el nombre de la tarjeta bancaria vinculada",
      "title": "Modificar nombre real",
      "xmpls": "Por favor, introduzca el nombre real"
    },
    "taskAmount": "Importe de la tarea",
    "thumb": "Pulgar",
    "ticketAmount": "Importe de la entrada",
    "total": "Total",
    "video": {
      "bofangliang": "Tiempos jugados",
      "goRecharge": "Recargar ahora",
      "rechargeToWatch": "Recarga para seguir viendo gratis",
      "trialEnded": "Prueba finalizada"
    },
    "waitingResultLabel": "Esperando resultado",
    "watchList": "Lista de vigilancia",
    "withdrawAmount": "Importe del retiro"
  },
  "fr": {
    "Hi": "Bonjour",
    "common": {
      "noMore": "Plus de données",
      "addbank": "Ajouter une carte de paiement",
      "confirmClearCache": "Voulez-vous vraiment vider le cache ?",
      "confirmDeleteHistory": "Êtes-vous sûr de vouloir supprimer cet élément de l'historique ?",
      "contactAdvisor": "Veuillez contacter votre conseiller",
      "deleteFailed": "Échec de la suppression",
      "deleteSuccess": "Supprimé avec succès",
      "imageTooLarge": "L'image est trop grande",
      "noallow": "La fonction est désactivée !",
      "pingluntitle": "Avis du manager",
      "pldtitle": "Détails de l'avis",
      "setbank": "Enregistrer un compte de retrait",
      "uploadFailed": "Échec du téléchargement",
      "uploading": "Téléchargement en cours..."
    },
    "login": {
      "loginFailed": "Échec de la connexion. Veuillez réessayer"
    },
    "moneylog": {
      "summary": "Résumé",
      "type1": "Recharger",
      "type2": "Bonus",
      "type4": "Bonus"
    },
    "accountOffline": "Compte hors ligne",
    "author": "Auteur :",
    "bankCard": "Carte bancaire",
    "choose": {
      "detail": "Détails",
      "giftAmount": "Montant du cadeau",
      "giftBalance": "Solde disponible",
      "giftConfirm": "Confirmer le cadeau",
      "giftCustomPlaceholder": "Saisissez un montant personnalisé",
      "giftInsufficient": "Solde insuffisant",
      "giftInvalid": "Veuillez saisir un montant de cadeau valide",
      "giftPoints": "Points",
      "giftSending": "Envoi en cours...",
      "giftSuccess": "Cadeau envoyé avec succès",
      "giftTitle": "Envoyer un cadeau",
      "jianjie": "Profil du manager",
      "move": "Mobilité disponible",
      "videodetail": "Vidéo en direct"
    },
    "completeTaskForMore": "Terminez les tâches pour obtenir plus de billets de cinéma",
    "home": {
      "gaoji": "Premium"
    },
    "movieTicket": "Billet de cinéma :",
    "myMovie": "Mon film",
    "orderContentLabel": "Contenu de la commande :",
    "personalReport": "Rapport personnel",
    "points": "Points",
    "possible": "Possible",
    "privacyPolicy": "Politique de confidentialité",
    "profitAmount": "Montant du bénéfice",
    "profitFormula": "Formule de calcul du bénéfice : Montant du gain - Montant de la tâche",
    "quantity": "Quantité :",
    "romanticDescription": "Notre service romantique protège la vie privée des membres en exigeant une vérification du nom réel ou une recommandation de membres vérifiés pour s'inscrire.",
    "setname": {
      "notreset": "Ne répétez pas les réglages !",
      "plsentername": "Veuillez saisir votre nom !",
      "tips": "Pour la sécurité de votre compte, le vrai nom doit correspondre au nom de la carte bancaire liée",
      "title": "Modifier le vrai nom",
      "xmpls": "Veuillez saisir votre vrai nom"
    },
    "taskAmount": "Montant de la tâche",
    "thumb": "Pouce",
    "ticketAmount": "Montant du billet",
    "total": "Total",
    "video": {
      "bofangliang": "Heures jouées",
      "goRecharge": "Recharger maintenant",
      "rechargeToWatch": "Veuillez recharger pour continuer à regarder gratuitement",
      "trialEnded": "Essai terminé"
    },
    "waitingResultLabel": "En attente de résultat",
    "watchList": "Liste de surveillance",
    "withdrawAmount": "Montant du retrait"
  },
  "de": {
    "Hi": "Hallo",
    "common": {
      "noMore": "Keine Daten mehr",
      "addbank": "Zahlungskarte hinzufügen",
      "confirmClearCache": "Sind Sie sicher, dass Sie den Cache leeren möchten?",
      "confirmDeleteHistory": "Möchten Sie dieses Verlaufselement wirklich löschen?",
      "contactAdvisor": "Bitte wenden Sie sich an Ihren Berater",
      "deleteFailed": "Löschen fehlgeschlagen",
      "deleteSuccess": "Erfolgreich gelöscht",
      "imageTooLarge": "Das Bild ist zu groß",
      "noallow": "Funktion ist deaktiviert!",
      "pingluntitle": "Manager-Bewertungen",
      "pldtitle": "Details überprüfen",
      "setbank": "Auszahlungskonto registrieren",
      "uploadFailed": "Upload fehlgeschlagen",
      "uploading": "Wird hochgeladen..."
    },
    "login": {
      "loginFailed": "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut"
    },
    "moneylog": {
      "summary": "Zusammenfassung",
      "type2": "Bonus",
      "type4": "Bonus"
    },
    "accountOffline": "Konto offline",
    "author": "Autor:",
    "bankCard": "Bankkarte",
    "choose": {
      "detail": "Details",
      "giftAmount": "Geschenkbetrag",
      "giftBalance": "Verfügbares Guthaben",
      "giftConfirm": "Geschenk bestätigen",
      "giftCustomPlaceholder": "Geben Sie einen benutzerdefinierten Betrag ein",
      "giftInsufficient": "Unzureichendes Guthaben",
      "giftInvalid": "Bitte geben Sie einen gültigen Geschenkbetrag ein",
      "giftPoints": "Punkte",
      "giftSending": "Wird gesendet...",
      "giftSuccess": "Geschenk erfolgreich gesendet",
      "giftTitle": "Ein Geschenk senden",
      "jianjie": "Manager-Profil",
      "move": "Mobilität verfügbar",
      "videodetail": "Live-Video"
    },
    "completeTaskForMore": "Erfülle Aufgaben, um mehr Kinokarten zu erhalten",
    "home": {
      "gaoji": "Premium"
    },
    "movieTicket": "Filmticket:",
    "myMovie": "Mein Film",
    "orderContentLabel": "Bestellinhalt:",
    "personalReport": "Persönlicher Bericht",
    "points": "Punkte",
    "possible": "Möglich",
    "privacyPolicy": "Datenschutzerklärung",
    "profitAmount": "Gewinnbetrag",
    "profitFormula": "Gewinnberechnungsformel: Gewinnbetrag - Aufgabenbetrag",
    "quantity": "Menge:",
    "romanticDescription": "Unser romantischer Service schützt die Privatsphäre der Mitglieder, indem er eine Verifizierung mit echtem Namen oder eine Empfehlung von verifizierten Mitgliedern zur Registrierung erfordert.",
    "setname": {
      "notreset": "Einstellungen nicht wiederholen!",
      "plsentername": "Bitte geben Sie Ihren Namen ein!",
      "tips": "Zu Ihrer Kontosicherheit muss der richtige Name mit dem Namen der gebundenen Bankkarte übereinstimmen",
      "title": "Echten Namen ändern",
      "xmpls": "Bitte geben Sie einen echten Namen ein"
    },
    "taskAmount": "Aufgabenbetrag",
    "thumb": "Daumen",
    "ticketAmount": "Ticketbetrag",
    "total": "Summe",
    "video": {
      "bofangliang": "Gespielte Zeiten",
      "goRecharge": "Jetzt aufladen",
      "rechargeToWatch": "Bitte laden Sie das Gerät auf, um es weiterhin kostenlos anzusehen",
      "trialEnded": "Testversion beendet"
    },
    "waitingResultLabel": "Warten auf Ergebnis",
    "watchList": "Beobachtungsliste",
    "withdrawAmount": "Auszahlungsbetrag"
  },
  "it": {
    "Hi": "Ciao",
    "common": {
      "noMore": "Non ci sono altri dati",
      "addbank": "Aggiungi carta di pagamento",
      "confirmClearCache": "Sei sicuro di voler svuotare la cache?",
      "confirmDeleteHistory": "Sei sicuro di voler eliminare questo elemento della cronologia?",
      "contactAdvisor": "Contatta il tuo consulente",
      "deleteFailed": "Eliminazione non riuscita",
      "deleteSuccess": "Eliminato con successo",
      "imageTooLarge": "L'immagine è troppo grande",
      "noallow": "La funzione è disabilitata!",
      "pingluntitle": "Recensioni del manager",
      "pldtitle": "Rivedi i dettagli",
      "setbank": "Registra conto di prelievo",
      "uploadFailed": "Caricamento non riuscito",
      "uploading": "Caricamento in corso..."
    },
    "login": {
      "loginFailed": "Accesso non riuscito. Riprova"
    },
    "moneylog": {
      "summary": "Sommario",
      "type2": "Bonus",
      "type4": "Bonus"
    },
    "accountOffline": "Account offline",
    "author": "Autore:",
    "bankCard": "Carta bancaria",
    "choose": {
      "detail": "Dettagli",
      "giftAmount": "Importo del regalo",
      "giftBalance": "Saldo disponibile",
      "giftConfirm": "Conferma regalo",
      "giftCustomPlaceholder": "Inserisci un importo personalizzato",
      "giftInsufficient": "Saldo insufficiente",
      "giftInvalid": "Inserisci un importo valido per il regalo",
      "giftPoints": "Punti",
      "giftSending": "Invio in corso...",
      "giftSuccess": "Regalo inviato con successo",
      "giftTitle": "Invia un regalo",
      "jianjie": "Profilo del manager",
      "move": "Mobilità disponibile",
      "videodetail": "Video dal vivo"
    },
    "completeTaskForMore": "Completa le attività per ottenere più biglietti per il cinema",
    "home": {
      "gaoji": "Premium"
    },
    "movieTicket": "Biglietto del cinema:",
    "myMovie": "Il mio film",
    "orderContentLabel": "Contenuto dell'ordine:",
    "personalReport": "Report personale",
    "points": "Punti",
    "possible": "Possibile",
    "privacyPolicy": "Informativa sulla privacy",
    "profitAmount": "Importo profitto",
    "profitFormula": "Formula di calcolo del profitto: importo vincente - importo dell'attività",
    "quantity": "Quantità:",
    "romanticDescription": "Il nostro servizio romantico protegge la privacy dei membri richiedendo la verifica del nome reale o la raccomandazione da parte dei membri verificati di registrarsi.",
    "setname": {
      "notreset": "Non ripetere le impostazioni!",
      "plsentername": "Inserisci il nome!",
      "tips": "Per la sicurezza del tuo account, il nome reale deve corrispondere al nome della carta di credito associata",
      "title": "Modifica nome reale",
      "xmpls": "Inserisci il nome reale"
    },
    "taskAmount": "Importo attività",
    "thumb": "Pollice",
    "ticketAmount": "Importo del biglietto",
    "total": "Totale",
    "video": {
      "bofangliang": "Volte giocate",
      "goRecharge": "Ricarica ora",
      "rechargeToWatch": "Ricarica per continuare a guardare gratuitamente",
      "trialEnded": "Prova terminata"
    },
    "waitingResultLabel": "In attesa del risultato",
    "watchList": "Elenco visualizzazioni",
    "withdrawAmount": "Importo del prelievo"
  }
}
